import { NgModule } from '@angular/core';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        clientId: `${environment.clientId}`,
        triggerAuthorizationResultEvent: true,
        logLevel: LogLevel.Debug,
        historyCleanupOff: false,
        authority: environment.apiUrl.slice(0, -1),
        redirectUrl: `${environment.frontUrl}callback`,
        postLogoutRedirectUri: `${environment.frontUrl.slice(0, -1)}`,
        scope: 'angualr openid profile role offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        disableIatOffsetValidation: true,

        maxIdTokenIatOffsetAllowedInSeconds: 600,
        renewTimeBeforeTokenExpiresInSeconds: 60,
      },
    }),
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
